import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const addParam = (params, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    params.append(key, value);
  }
};

const promotionController = {
  addCampaign: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/promotion/v1/addCampaign",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getPromotions: ({ Authorization, jwt } = {}) => {
    return Utils.controller(
      "api/promotion/v1/getPromotions",
      "",
      "GET",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  deletePromotionByProductOfferId: ({
    Authorization,
    jwt,
    productOfferId,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "productOfferId", productOfferId);

    return Utils.controller(
      "api/promotion/v1/deletePromotionByProductOfferId",
      "",
      "DELETE",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  editPromotion: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/promotion/v1/editPromotion",
      request,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getPromotionDetailsById: ({ Authorization, jwt, productOfferId } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "productOfferId", productOfferId);

    return Utils.controller(
      "api/promotion/v1/getPromotionDetailsById",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getCampaignsNameAndId: ({ Authorization, jwt } = {}) => {
    return Utils.controller(
      "api/promotion/v1/getCampaignsNameAndId",
      "",
      "GET",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
};

export default promotionController;
